export type RegistrationFormState = {
  orderNumber: string;
  manufacturer: string;
  model: string;
  productType: string;
  productTypeId: string;
  warrantyStartDate: string;
  serial: string;
  chargerIncluded: boolean;
  adapterYesNo: string;
  damageNotes: string;
  customer: string;
  customerKey: string;
  articleNumber: string;
  photos: Record<string, string | null>;
  reuse: boolean;
  resold: boolean;
  scrap: boolean;
  salesBatchId: string;
  salesBatchName: string;
  salesKolliId: string;
  salesKolliName: string;
  salesCpu: string;
  salesStorage: string;
  salesRam: string;
};

export function createEmptyRegistrationForm(): RegistrationFormState {
  return {
    orderNumber: "",
    manufacturer: "",
    model: "",
    productType: "",
    productTypeId: "",
    warrantyStartDate: "",
    serial: "",
    chargerIncluded: false,
    adapterYesNo: "",
    damageNotes: "",
    customer: "",
    customerKey: "",
    articleNumber: "",
    photos: { keyboard: null, screen: null, underside: null, topside: null },
    reuse: false,
    resold: false,
    scrap: false,
    salesBatchId: "",
    salesBatchName: "",
    salesKolliId: "",
    salesKolliName: "",
    salesCpu: "",
    salesStorage: "",
    salesRam: "",
  };
}
